import React from "react";

import { ReactComponent as UploadIcon } from "src/images/upload-file.svg";
import IDHFormattedMessage from "../IDHFormattedMessage/IDHFormattedMessage";

import "./FileUploader.scss";

interface FileUploaderProps {
  maxFileSizeInMB?: number;
  supportedFormats?: string[];
  handleOpenFileUploader?: () => void;
}

export default function FileUploader({
  maxFileSizeInMB,
  supportedFormats,
  handleOpenFileUploader,
}: FileUploaderProps) {
  return (
    <div className="file-uploader" onClick={handleOpenFileUploader}>
      <div className="file-uploader__content">
        <div className="file-uploader__cta">
          <UploadIcon />
          <IDHFormattedMessage
            id="ws_upload_file"
            defaultMessage="Upload file"
          />
        </div>

        {(supportedFormats || maxFileSizeInMB) && (
          <div className="file-uploader__info">
            {supportedFormats && (
              <span className="file-uploader__formats">
                <IDHFormattedMessage id="ws_formats" defaultMessage="Formats" />{" "}
                {supportedFormats.join(", ")}
              </span>
            )}

            {maxFileSizeInMB && (
              <span className="file-uploader__max-file-size">
                <IDHFormattedMessage
                  id="ws_max_file_size"
                  defaultMessage="Max file size"
                />{" "}
                {maxFileSizeInMB}MB
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
